module.exports = "/_next/static/images/0884d6b7cec6f11a6df2f4af3b0a88a6-savings-waitlist-promise-1b-lg-1x.jpg";